<template>
    <div>
        <surePop @closesure="closesure" class="addEmail">
            <div slot="surecon">
                <div class="title flexible aItem-center jc-center f20 text-333 font-MT">
                    {{$lang('authorCenter.stories.newChapterPlace[4]')}}
                </div>
                <el-form ref="form" class="mt20" :rules="rules" :model="form">
                    <el-form-item :label="$lang('authorCenter.stories.contractLabel[2]')" prop="email" align="left">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="optionbox" class="btn-item flexible jc-center">
                <el-button size="medium" class="f16 font-MT ml20" @click="addEmail()">{{$lang('authorCenter.stories.confirm')}}</el-button>
                <el-button size="medium" class="el-button-opa f16 font-MT ml24" @click="closesure(false)">{{$lang('authorCenter.stories.cancel')}}</el-button>
            </div>
        </surePop>
    </div>
</template>

<script>
    import {authoremail} from '@/api/author'
    export default {
        name: "",
        props: ['book'],
        data () {
            return {
                form: {
                   email: ''
                },
                rules: {
                    email: [
                        { required: true, message: this.$lang('authorCenter.stories.contractPlace[0]'), trigger: "blur" },
                        { type: 'email', message: this.$lang('authorCenter.stories.newChapterPlace[5]'), trigger: ['blur', 'change'] }
                    ],
                },
                isShowPop: false
            }
        },
        methods: {
            addEmail () {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        authoremail({email: this.form.email}).then(res=>{
                            if (res.success) {
                                this.$router.push(`/authorManage/newChapter/${this.book.id}/0/${this.book.allowPrice}`);
                                this.closesure(false)
                            }
                        })
                    }

                })

            },
            closesure (data) {
                this.$emit('closeEmail', data)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .addEmail{

        /deep/.surecon{
            width: 534px!important;
            margin: auto;
        }
        /deep/.el-form-item__label{
            font-size: 20px!important;
            font-family: "Arial Rounded MT Bold";
            color: #333;
            float: none;
        }
        .AE-tip{
            width: 534px;
        }
    }
</style>
